import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as o, createElementVNode as n } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconVideoOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, f = ["aria-label", "data-qa", "aria-hidden"];
function m(e, t, r, u, _, a) {
  return d(), l("svg", {
    "aria-label": r.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--video-off"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Video Off",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    n("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M.646.646a.5.5 0 0 1 .708 0l10 10a.5.5 0 0 1-.708.708l-1.949-1.95a1.5 1.5 0 0 1-1.198.598H2a1.5 1.5 0 0 1-1.5-1.5V3.498a1.5 1.5 0 0 1 .911-1.38l-.765-.764a.5.5 0 0 1 0-.708Zm1.645 2.352H2a.5.5 0 0 0-.5.5v5.004a.5.5 0 0 0 .5.5h5.499a.5.5 0 0 0 .468-.325L2.291 2.998Zm5.208 0h-1.67a.5.5 0 0 1 0-1h1.67a1.5 1.5 0 0 1 1.5 1.5v.758l1.817-.72A.5.5 0 0 1 11.5 4v4a.5.5 0 0 1-1 0V4.736l-1.816.72A.5.5 0 0 1 8 4.993l-.001-.5v-.995a.5.5 0 0 0-.5-.5Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, f);
}
const b = /* @__PURE__ */ s(c, [["render", m]]);
export {
  b as default
};
//# sourceMappingURL=video-off.js.map
